export const APP_SETTINGS_KEY = "APP_SETTINGS";

export const APP_SETTINGS_CACHE_KEYS = {
  DETAIL: [APP_SETTINGS_KEY, "DETAIL"] as const,
};
